<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <button
        class="btn-close p-0"
        type="button"
        data-bs-dismiss="modal"
        aria-label="Close"
        style="background: transparent"
        @click="closeModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
        >
          <circle cx="17.5" cy="17.5" r="17.5" fill="#A3A3A3" />
          <path
            d="M17.5 0C7.84972 0 0 7.85167 0 17.5C0 27.1483 7.84972 35 17.5 35C27.1503 35 35 27.1483 35 17.5C35 7.85167 27.1503 0 17.5 0ZM17.5 32.5C9.99639 32.5 2.5 25.0056 2.5 17.5C2.5 9.99444 9.99639 2.5 17.5 2.5C25.0036 2.5 32.5 9.99444 32.5 17.5C32.5 25.0056 25.0036 32.5 17.5 32.5ZM18.8747 17.5L24.0197 12.355C24.202 12.1727 24.3044 11.9254 24.3044 11.6676C24.3044 11.4098 24.202 11.1626 24.0197 10.9803C23.8374 10.798 23.5902 10.6956 23.3324 10.6956C23.0746 10.6956 22.8273 10.798 22.645 10.9803L17.5 16.1253L12.355 10.9783C12.1716 10.8012 11.9261 10.7032 11.6711 10.7055C11.4162 10.7077 11.1724 10.8099 10.9921 10.9902C10.8119 11.1704 10.7096 11.4143 10.7074 11.6692C10.7052 11.9241 10.8032 12.1697 10.9803 12.3531L16.1253 17.5L10.9803 22.645C10.7977 22.8273 10.6951 23.0747 10.6949 23.3326C10.6947 23.5906 10.797 23.8381 10.9793 24.0207C11.1616 24.2033 11.409 24.3059 11.667 24.3061C11.9249 24.3063 12.1724 24.204 12.355 24.0217L17.5 18.8747L22.645 24.0197C22.7346 24.1127 22.8417 24.1869 22.9603 24.238C23.0788 24.2891 23.2063 24.3161 23.3354 24.3174C23.4645 24.3187 23.5926 24.2943 23.7121 24.2456C23.8317 24.1969 23.9403 24.1248 24.0317 24.0337C24.1231 23.9425 24.1955 23.8341 24.2445 23.7147C24.2936 23.5953 24.3184 23.4673 24.3174 23.3382C24.3165 23.2091 24.2899 23.0815 24.2391 22.9628C24.1883 22.8441 24.1144 22.7368 24.0217 22.6469L18.8747 17.5Z"
            fill="white"
          />
        </svg>
      </button>
      <div class="modal-header">
        <h5 class="modal-title">
          {{ mode === "edit" ? "Edit User" : "Add New User" }}
        </h5>
      </div>
      <div class="modal-body">
        <form autocomplete="off">
          <div class="mb-3">
            <label class="col-form-label" for="full-name">Full Name</label>
            <input
              class="form-control"
              autocomplete="new-text"
              id="full-name"
              type="text"
              v-model="fullName"
            />
          </div>
          <div class="mb-3">
            <label class="col-form-label" for="email">Email</label>
            <input
              class="form-control"
              id="email"
              type="email"
              v-model="email"
              autocomplete="new-email"
            />
          </div>
          <div class="mb-3">
            <label class="col-form-label" for="phoneNo">Phone Number</label>
            <input
              class="form-control"
              id="phoneNo"
              type="phoneNo"
              v-model="phoneNo"
              autocomplete="new-text"
            />
          </div>
          <div class="mb-3">
            <label class="col-form-label" for="password">Password</label>
            <input
              class="form-control"
              id="password"
              type="password"
              v-model="password"
              autocomplete="new-password"
            />
            <div class="form-group">
              <ul>
                <li class="d-flex align-items-center" id="minLength">
                  <img
                    style="margin-right: 14px; height: 12px; width: 12px"
                    :src="levelImg"
                  />Password strength :
                  <span style="margin-left: 10px">{{ levelPassword }}</span>
                </li>
                <li class="d-flex align-items-center" id="uppercase">
                  <img
                    style="margin-right: 14px; height: 12px; width: 12px"
                    :src="minLengthImg"
                  />At least 8 characters
                </li>
                <li class="d-flex align-items-center" id="lowercase">
                  <img
                    style="margin-right: 14px; height: 12px; width: 12px"
                    :src="hasUppercaseImg"
                  />Must include uppercase
                </li>
                <li class="d-flex align-items-center" id="symbol">
                  <img
                    style="margin-right: 14px; height: 12px; width: 12px"
                    :src="hasNumberOrSymbolImg"
                  />Must include number or symbol
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-3">
            <label class="col-form-label" for="confirm-password"
              >Confirm Password</label
            >
            <input
              :class="`form-control${
                passwordNotMatch !== undefined
                  ? passwordNotMatch
                    ? ' is-invalid'
                    : ' is-valid'
                  : ''
              }`"
              id="confirm-password"
              type="password"
              v-model="confirmPassword"
            />
            <div class="invalid-feedback">Password not match</div>
          </div>
          <div class="mb-3">
            <label class="col-form-label" for="user-type"
              >User Access Level</label
            >
            <div class="user-type-dropdown dropdown">
              <button
                class="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="user-type"
              >
                {{
                  selectedUserAccessLevel.AccessLevelID === ""
                    ? "Select user type"
                    : selectedUserAccessLevel.AccessLevelName
                }}
              </button>
              <div
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="user-type"
              >
                <a
                  v-for="option in userAccessLevel"
                  :key="option"
                  class="dropdown-item"
                  :class="
                    option.AccessLevelID ===
                    selectedUserAccessLevel.AccessLevelID
                      ? 'active'
                      : ''
                  "
                  @click="selectedUserAccessLevel = option"
                  href="javascript:void(0)"
                  >{{ option.AccessLevelName }}</a
                >
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          class="btn"
          type="button"
          data-bs-dismiss="modal"
          @click="handleSave"
        >
          Save
        </button>
        <button
          v-show="mode === 'edit'"
          class="btn btn-danger"
          type="button"
          data-bs-dismiss="modal"
          @click="handleDelete"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  props: ["isEdit", "formEdit"],
  watch: {
    confirmPassword(val) {
      if (this.password === "" || val === "") {
        this.passwordNotMatch = undefined;
        return;
      }
      this.passwordNotMatch = val !== this.password;
    },
    isEdit: {
      handler: function (val) {
        this.mode = val ? "edit" : "add";
        this.fullName = val ? this.formEdit.username : "";
        this.email = val ? this.formEdit.email : "";
        this.phoneNo = val ? this.formEdit.contactNo : "";
        this.selectedUserAccessLevel = val
          ? {
              AccessLevelID: this.formEdit.AccessLevelID,
              AccessLevelName: this.formEdit.AccessLevelName,
            }
          : { AccessLevelID: "", AccessLevelName: "" };
      },
      deep: true,
    },
    formEdit(val) {
      this.mode = this.isEdit ? "edit" : "add";
      this.fullName = val.username;
      this.email = val.email;
      this.phoneNo = val.contactNo;
      this.selectedUserAccessLevel = {
        AccessLevelID: val.AccessLevelID,
        AccessLevelName: val.AccessLevelName,
      };
    },
    password(val) {
      if (this.password === "" || val === "") {
        this.passwordNotMatch = undefined;
        return;
      }
      this.passwordNotMatch = val !== this.confirmPassword;
    },
  },
  computed: {
    // ...mapState({
    //   userAccessLevel: (state) => state.common.userAccessLevel,
    // }),
    levelPassword() {
      return this.calculatePasswordEntropy(this.password).strength;
    },
    colorStrength() {
      switch (this.calculatePasswordEntropy(this.password).strength) {
        case "Strong":
          return "#44c4a1";

        case "Medium":
          return "#ffab07";
        default:
          return "#dc3545";
      }
    },
    levelImg() {
      return this.levelPassword === "Strong"
        ? require("../../../assets/images/icon/checklist.png")
        : require("../../../assets/images/icon/unchecklist.png");
    },
    minLengthImg() {
      return this.minChar(8)
        ? require("../../../assets/images/icon/checklist.png")
        : require("../../../assets/images/icon/unchecklist.png");
    },
    hasUppercaseImg() {
      return this.hasUppercase()
        ? require("../../../assets/images/icon/checklist.png")
        : require("../../../assets/images/icon/unchecklist.png");
    },
    hasNumberOrSymbolImg() {
      return this.hasNumberOrSymbol()
        ? require("../../../assets/images/icon/checklist.png")
        : require("../../../assets/images/icon/unchecklist.png");
    },
  },
  data() {
    return {
      mode: "add",
      fullName: "",
      email: "",
      phoneNo: "",
      password: "",
      confirmPassword: "",
      selectedUserAccessLevel: {
        AccessLevelID: "",
        AccessLevelName: "",
      },
      passwordNotMatch: undefined,
      getNotify: false,
      userAccessLevel: [
        {
          AccessLevelID: "Enforcement",
          AccessLevelName: "Enforcement",
        },
        {
          AccessLevelID: "Traffic Teams",
          AccessLevelName: "Traffic Teams",
        },
        {
          AccessLevelID: "Management",
          AccessLevelName: "Management",
        },
        {
          AccessLevelID: "Data Science",
          AccessLevelName: "Data Science",
        },
        {
          AccessLevelID: "Guest",
          AccessLevelName: "Guest",
        },
        {
          AccessLevelID: "IT Team",
          AccessLevelName: "IT Team",
        },
        {
          AccessLevelID: "Super Admin",
          AccessLevelName: "Super Admin",
        },
      ],
    };
  },
  emits: ["closeModal", "onDelete", "onSave"],
  methods: {
    closeModal() {
      this.resetForm();
      this.$emit("closeModal");
    },
    handleSave() {
      this.$emit("onSave", {
        UserName: this.fullName,
        Password: this.confirmPassword,
        Email: this.email,
        AccessLevelID: this.selectedUserAccessLevel.AccessLevelID,
      });
      this.resetForm();
    },
    handleDelete() {
      this.resetForm();
      this.$emit("onDelete");
    },
    resetForm() {
      this.fullName = "";
      this.email = "";
      this.password = "";
      this.confirmPassword = "";
      this.selectedUserAccessLevel = {
        AccessLevelID: "",
        AccessLevelName: "",
      };
      this.passwordNotMatch = undefined;
    },
    minChar(num) {
      const passwordLength = this.password.length;
      return passwordLength >= num;
    },
    hasUppercase() {
      if (/[A-Z]/.test(this.password)) {
        return true;
      }
      return false;
    },
    hasNumberOrSymbol() {
      if (/[0-9]/.test(this.password) || /[^a-zA-Z]/.test(this.password)) {
        return true;
      }
      return false;
    },
    calculatePasswordEntropy(password) {
      let charsetSize = 0;
      if (/[a-z]/.test(password)) charsetSize += 26;
      if (/[A-Z]/.test(password)) charsetSize += 26;
      if (/[0-9]/.test(password)) charsetSize += 10;
      if (/[^a-zA-Z0-9]/.test(password)) charsetSize += 32; // Special characters

      const passwordLength = password.length;
      const entropy = passwordLength * Math.log2(charsetSize);

      let strength;
      if (entropy < 28 || passwordLength === 0) {
        strength = "Weak";
      } else if (entropy < 56) {
        strength = "Medium";
      } else {
        strength = "Strong";
      }

      return { entropy: entropy.toFixed(2), strength: strength };
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  max-width: 425px;
  margin-top: 51px;
}
.modal-content {
  border: none;
  color: #009a78;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.form-group {
  color: #8f8f8f;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 12px;
  span {
    color: v-bind("colorStrength");
  }
}
.modal-body {
  padding: 40px 35px;
}
input,
select {
  height: 51px;
  background: #f0f0f0;
  border: none;
}
.user-type-dropdown {
  button {
    color: #9b9a9a;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border: none;
    padding: 16px 20px;
    width: 100%;
    text-align: left;
    border-radius: 8px;
    background: #f0f0f0;
    &:active {
      border: none;
    }
    &::after {
      color: #009a78;
      right: 25px;
    }
  }
}
.modal-header {
  border-radius: 8px 8px 0px 0px;
  background: #009a78;
  color: #fff;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.modal-footer {
  border-top: 1px solid #e0e0e0;
  padding: 40px 35px 40px;
  button {
    width: 100%;
    height: 51px;
    margin: 0;
    border: none;
    border-radius: 8px;
    background: #009a78;
    color: white;
    &.btn-danger {
      border-radius: 8px;
      margin-top: 20px;
      background-color: #ff9700 !important;
      border-color: #ff9700 !important;
    }
  }
}

.btn-close {
  width: 35px;
  height: 35px;
  position: absolute;
  top: -2px;
  right: -44px;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
}
</style>